import styles from "./TournamentView.module.css";

const TournamentView = ({ tournamentData }) => {
  const renderPlayer = (match, playerKey) => {
    const isWinner =
      (playerKey === "player1" && match.winner === 1) ||
      (playerKey === "player2" && match.winner === 2);
    return (
      <div>
        {match[playerKey]}
        {isWinner && <span className={styles.winner}>WIN</span>}
      </div>
    );
  };

  const renderPlayers = (match) => {
    if (match.winner === 2) {
      return (
        <>
          {renderPlayer(match, "player2")}
          <br />
          {renderPlayer(match, "player1")}
        </>
      );
    } else {
      return (
        <>
          {renderPlayer(match, "player1")}
          <br />
          {renderPlayer(match, "player2")}
        </>
      );
    }
  };

  return (
    <div className="bracket">
      {/* 왼쪽 16강 (4개 매치) */}
      <div className={styles.round}>
        {tournamentData.round16.slice(0, 4).map((match, i) => (
          <div
            key={i}
            className={`${styles.match} ${
              i % 2 === 0 ? styles.matchBt : styles.matchTop
            }`}
          >
            {renderPlayers(match)}
          </div>
        ))}
      </div>

      {/* 왼쪽 8강 (2개 매치) */}
      <div className={styles.round}>
        {tournamentData.round8.slice(0, 2).map((match, i) => (
          <div key={i} className={styles.roundTitle}>
            {renderPlayers(match)}
          </div>
        ))}
        <span className={`${styles.roundTitleLine} ${styles.lineRight}`}></span>
      </div>

      {/* 왼쪽 4강 (1개 매치) */}
      <div className={styles.round}>
        <div
          className={`${styles.roundTitleSemi} ${styles.roundTitleSemiLeft}`}
        >
          Semi Final
          <br />
          <br />
          {renderPlayers(tournamentData.round4[0])}
        </div>
      </div>

      {/* 결승 & 3/4위전 */}
      <div className={styles.round}>
        <div className={styles.final}>
          Final
          <br />
          <br />
          {renderPlayers(tournamentData.round2[0])}
        </div>
        <div className={styles.semiFinal}>
          3/4
          <br />
          <br />
          {renderPlayers(tournamentData.round3[0])}
        </div>
      </div>

      {/* 오른쪽 4강 (1개 매치) */}
      <div className={styles.round}>
        <div
          className={`${styles.roundTitleSemi} ${styles.roundTitleSemiRight}`}
        >
          Semi Final
          <br />
          <br />
          {renderPlayers(tournamentData.round4[1])}
        </div>
      </div>

      {/* 오른쪽 8강 (2개 매치) */}
      <div className={styles.round}>
        <span className={`${styles.roundTitleLine} ${styles.lineLeft}`}></span>
        {tournamentData.round8.slice(2, 4).map((match, i) => (
          <div key={i} className={styles.roundTitle}>
            {renderPlayers(match)}
          </div>
        ))}
      </div>

      {/* 오른쪽 16강 (4개 매치) */}
      <div className={styles.round}>
        {tournamentData.round16.slice(4, 8).map((match, i) => (
          <div
            key={i}
            className={`${styles.match} ${
              i % 2 === 0 ? styles.matchBt : styles.matchTop
            } ${styles.matchLeft}`}
          >
            {renderPlayers(match)}
          </div>
        ))}
      </div>
    </div>
  );
};
export default TournamentView;
